import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {fetchSubscription, fetchManageSubscription, fetchManageSubType, fetchCustomers} from "../../../../../actions";
import {Badge, Col, Row} from "reactstrap";
import BBIconCheck from "../../../../../assets/bbCustomIcons/BBIconCheck";
import {Tooltip} from "@mui/material";
import {Button} from "@material-ui/core";
import Widget from "../../../../../components/prefabricated/Widget";
import BBIconQuestionSpeechBubbleRequest from "../../../../../assets/bbCustomIcons/BBIconQuestionSpeechBubbleRequest";
import SkeletonMangeSubscriptionTable
    from "../../../../../components/customBreachBits/admin/SkeletonMangeSubscriptionTable";
import BBIconConstructionCone from "../../../../../assets/bbCustomIcons/BBIconConstructionCone";
import {
    bbFindEntityWithinPortfolioOrSelf,
    bbIsUserManagerOfEntity,
    isCurrentUserMemberOf
} from "../../../../../util/bbHelpers";
import PageTitleGraphic from "../../../../../assets/images/BreachRisk_Manage_Subscription_Banner.svg";

const CustomCheck = () =>{
    return(
        <BBIconCheck style={{fontSize: "1.25em"}} className={"mb-0 pb-0"}/>
    )
}

const defaultSubscriptionObj={
        "1": {
            "id": 1,
            "name": "BreachRisk™ Portfolio",
            "description": "View and monitor the BreachRisk of organizations you care about.",
            "levels": [
                {
                    "id": 1,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 1,
                    "name": "trial",
                    "description": "Trial of the BreachRisk Portfolio service.",
                    "entities": 2,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false
                },
                {
                    "id": 2,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 1,
                    "name": "starter",
                    "description": "BreachRisk Portfolio starter subscription",
                    "entities": 5,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false
                },
                {
                    "id": 3,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 1,
                    "name": "pro",
                    "description": "BreachRisk Portfolio pro subscription",
                    "entities": 35,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false
                },
                {
                    "id": 4,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 1,
                    "name": "premium",
                    "description": "BreachRisk Portfolio premium subscription",
                    "entities": 100,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false
                }
            ],
            "self_subscription_eligible": false
        },
        "2": {
            "id": 2,
            "name": "BreachRisk™ for Business",
            "description": "View and monitor your organization's BreachRisk.",
            "levels": [
                {
                    "id": 5,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 2,
                    "name": "trial",
                    "description": "Trial of BreachRisk monitoring service at the Lite level.",
                    "entities": 1,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false
                },
                {
                    "id": 6,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 2,
                    "name": "lite",
                    "description": "Includes BreachRisk score and assessment conducted without testing.",
                    "entities": 1,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false,
                },
                {
                    "id": 7,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 2,
                    "name": "pro",
                    "description": "Includes BreachRisk Lite benefits, plus increased confidence in BreachRisk score through scanning and breach attempts of your attack vectors.",
                    "entities": 1,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false,
                },
                {
                    "id": 10,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 2,
                    "name": "free",
                    "description": "Free BreachRisk subscription to see BreachRisk assessments ordered by others on your organization.",
                    "entities": 1,
                    "monthly_price": 0,
                    "price_id": null,
                    "subscribed": false,
                    "discount": false,
                    "discount_price": null
                },
                {
                    "id": 11,
                    "stripe_product_id": null,
                    "stripe_product_id_live": null,
                    "subscription_type": 2,
                    "name": "premium",
                    "description": "Premium BreachRisk subscription, including daily BreachRisk assessments and advanced testing.",
                    "entities": 1,
                    "monthly_price": null,
                    "price_id": null,
                    "subscribed": false,
                }
            ],
            "self_subscription_eligible": false
        }
}

const ManageSubscriptionPage = ({props})=>{

    const {authUser,  } = useSelector(({auth})=> auth);
    const {customers, customerInView} = useSelector(({customer})=> customer);
    const {entityInView, portfolios} = useSelector(({breachrisk}) => breachrisk);
    const {stripeRedirectURL, loadingSubscriptions, errorLoadingSubscriptions,loadingStripeRedirectURL, errorStripeRedirectURL,
        stripeRedirectURLSubType, loadingStripeRedirectURLSubType, errorStripeRedirectURLSubType,  subscriptionInfo} = useSelector(({admin})=> admin);

    const entities = portfolios
    && portfolios[customerInView]
        ? portfolios[customerInView].entities
        : null;

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerInView);

    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const dispatch = useDispatch();

    const customer = customers && customerInView && customers[customerInView] ? customers[customerInView] : null;

    const authUserCustomerArray = authUser && authUser.customers && Array.isArray(authUser.customers)
        ? authUser.customers
        : null;

    const userCustomerObjectInView = authUserCustomerArray
        && authUserCustomerArray.find((customer)=> customer.customer === customerInView)

    // const authUserIsManager = userCustomerObjectInView && userCustomerObjectInView.manager;

    const authUserIsManager = bbIsUserManagerOfEntity(authUser, entityInView);

    // const subscriptionInfo = testDataSubscriptionObj;
    const [selectSubTypeToView, setSelectSubTypeToView] = useState(2);

    const subscriptionInfoObj = subscriptionInfo && subscriptionInfo[customerInView] && subscriptionInfo[customerInView][selectSubTypeToView] ? subscriptionInfo[customerInView][selectSubTypeToView] : defaultSubscriptionObj[selectSubTypeToView];
    const customerSubscriptions = customer && customer.Subscriptions;

    const customerSubscriptionsArray = customerSubscriptions && Object.values(customerSubscriptions);
    const customerSubscriptionsArrayForSubType = customerSubscriptions && customerSubscriptionsArray.filter((sub)=> sub && sub.subscription_type && sub.subscription_type.id === selectSubTypeToView)
    const customerSubscriptionsLevelsArray = customerSubscriptionsArrayForSubType  && customerSubscriptionsArrayForSubType.map(sub =>sub.subscription_level);

    const subscriptionName = subscriptionInfoObj && subscriptionInfoObj.name;
    const subscriptionDescription = subscriptionInfoObj && subscriptionInfoObj.description;
    const selfManagedEligible = subscriptionInfoObj && subscriptionInfoObj.self_subscription_eligible;
    const subLevelsArray = subscriptionInfoObj && Array.isArray(subscriptionInfoObj.levels) && subscriptionInfoObj.levels;
    const subLevelsCustomerSubscribedTrue = subLevelsArray && subLevelsArray.filter(sub => sub.subscribed === true)

    const [selectSubTypeClicked, setSelectSubTypeClicked] = useState(null);

    useEffect(()=>{
        if(authUser && customerInView  && customer && !loadingSubscriptions[customerInView] && !subscriptionInfo[customerInView]){
            dispatch(fetchSubscription({
                customerId: customerInView
            }))
        }
        if(authUser
            && subscriptionInfo[customerInView]
            && selfManagedEligible
            && !stripeRedirectURL
            && !loadingStripeRedirectURL[customerInView]
            && !errorStripeRedirectURL[customerInView]){
            dispatch(fetchManageSubscription({customerId : customerInView}))
        }

    }, [authUser, loadingSubscriptions, stripeRedirectURL, subscriptionInfo, loadingStripeRedirectURL, errorStripeRedirectURL, customerInView])

    useEffect(()=>{
        if(customerSubscriptionsLevelsArray
            && subLevelsCustomerSubscribedTrue
            && customerSubscriptionsLevelsArray.length !== subLevelsCustomerSubscribedTrue.length){
            dispatch(fetchCustomers());
        }
    }, [subscriptionInfo])

    const handleClick = ()=>{
        // if(selfManagedEligible && stripeRedirectURL){
            console.log("Redirecting to a new window", stripeRedirectURL);
            window.open(stripeRedirectURL, "_self");
        // }
    }

    const handleClickSubType = (subType) => {
        // if(selfManagedEligible  && !loadingStripeRedirectURLSubType[customerInView]){
            console.log("dispatch action to fetch manage subscription sub type for", customerInView, "for subType", subType);
            dispatch(fetchManageSubType(
                {customerId : customerInView,
                       subType: subType,
                }))
        // }

        setSelectSubTypeClicked(true);

    }


    if(selfManagedEligible && stripeRedirectURLSubType && selectSubTypeClicked){
        console.log("Redirecting to a new window", stripeRedirectURLSubType);
        window.open(stripeRedirectURLSubType, "_self");
        setSelectSubTypeClicked(false);

    }

    const indexOfTrialLevel = subLevelsArray
        && subLevelsArray
            .findIndex((x)=> x.name === "trial");
    const indexOfFreeLevel = selectSubTypeToView === 2
        && subLevelsArray
        && subLevelsArray
            .findIndex((x)=> x.name === "free");
    const freeLevel = selectSubTypeToView === 2
        && subLevelsArray
        && indexOfFreeLevel
        && subLevelsArray[indexOfFreeLevel];

    if(selectSubTypeToView === 2
        && subLevelsArray
        && indexOfFreeLevel !== 0){

        subLevelsArray.splice(subLevelsArray.findIndex((x)=> x.name === "free"), 1);
        subLevelsArray[0] = freeLevel;

    } else if(subLevelsArray
        && subLevelsArray.find((x)=> x.name === "trial")){
        subLevelsArray.splice(subLevelsArray.findIndex((x)=> x.name === "trial"), 1);
    }

    console.log("This is subLevelsArray", subLevelsArray, "this is subscriptionInfoOb", subscriptionInfoObj)
    const subscriptionInfoArray = subLevelsArray
        && subLevelsArray.map((level)=>{
            if(selectSubTypeToView === 2) {
                const priceId = level && level.price_id && level.price_id.lastIndexOf(":") ? level.price_id.slice(level.price_id.lastIndexOf(":") +1) : null;
                return{
                    // ...level,
                    subscribed: level.subscribed,
                    id: level.id,
                    "Name": <h3>{level.name.toUpperCase()}</h3>,
                    // "Description": <em>{level.description}</em>,
                    "Price": level.discount && level.name !== "free" && level.monthly_price && selfManagedEligible
                        ? <p>
                            <span title={"Discounted Price"}><strong className={"text-red"}>${level.discount_price.toFixed(2)}</strong></span>&nbsp;
                            <small><s>${level.monthly_price}</s></small>
                    </p>
                        : level.monthly_price && level.name !== "free" && selfManagedEligible
                        ? <p>${level.monthly_price}/month</p>
                        : level.name === "free"
                            ? <p>--</p>
                        : <p><Tooltip title={"This information is not available. Your company may require a custom quote or else we are waiting on further information. Please contact BreachBits for more information."}>
                            <span>
                                <BBIconQuestionSpeechBubbleRequest/>
                            </span>
                        </Tooltip>
                        </p>,
                    // "Price": <p>{level.discount && level.name !== "free" ? level.discount_price : "false"}</p>,
                    "BreachRisk™ Score": <CustomCheck/>,
                    "BreachRisk™ Report": <CustomCheck/>,
                    "Share BreachRisk™ Report": <CustomCheck/>,
                    "Add Additional Infrastructure": <CustomCheck/>,
                    "Cloud Integration": <CustomCheck/>,
                    "Threat Vector Validation":  <CustomCheck/>,
                    // "Up to 100 public-facing IPs": <CustomCheck/>,
                    "BreachRisk™ Email Updates": level.name === "free"
                        ? <code className={"bg-bb-risk-highest text-white p-1"} style={{fontSize: ".75em"}}>QUARTERLY</code>
                        : level.name === "lite"
                            ? <code className={"bg-bb-risk-high text-white p-1"}  style={{fontSize: ".75em"}}>MONTHLY</code>
                        : level.name === "pro"
                                ? <code className={"bg-bb-risk-low text-white p-1"}  style={{fontSize: ".75em"}}>WEEKLY</code>
                        : level.name === "premium"
                                    ?<code className={"bg-bb-risk-lowest text-white p-1"}  style={{fontSize: ".75em"}}>WEEKLY + ON DEMAND</code>
                        : null,
                    "BreachRisk™ Assessment Periodicity": level.name === "free"
                        ? <code className={"bg-bb-risk-highest text-white p-1"} style={{fontSize: ".75em"}}>QUARTERLY</code>
                        : level.name === "lite"
                            ? <code className={"bg-bb-risk-high text-white p-1"} style={{fontSize: ".75em"}}>MONTHLY</code>
                            : level.name === "pro"
                                ? <code className={"bg-bb-risk-low text-white p-1"} style={{fontSize: ".75em"}}>WEEKLY</code>
                                : level.name === "premium"
                                    ?<code className={"bg-bb-risk-lowest text-white p-1"}  style={{fontSize: ".75em"}}>WEEKLY + ON DEMAND</code>
                                    : null,
                    "BreachRisk™ Technical Details": level.name !== "free"
                        ? <CustomCheck/>
                        : null,
                    "Active Penetration Testing": (level.name === "pro" || level.name === "premium")
                        ? <CustomCheck/>
                        : null,
                    // "Integrate Actions": (level.name === "pro" || level.name === "premium")
                    //     ? <CustomCheck/>
                    //     : null,
                    // "Early Access Eligibility": (level.name === "pro" || level.name === "premium")
                    //     ? <CustomCheck/>
                    //     : null,
                    // "Increased Fidelity": (level.name === "pro" || level.name === "premium")
                    //     ? <CustomCheck/>
                    //     : null,
                    "Certified Penetration Testing Reports": (level.name === "free" || level.name === "lite")
                        ? null
                        : level.name === "pro"
                            ? <code className={"bg-yellow p-1"} style={{fontSize: ".75em"}}>Add On Available</code>
                            : level.name === "premium"
                            ? <CustomCheck/>
                    : null,
                    // "Daily Assessment": level.name === "premium"
                    //     ? <CustomCheck/>
                    //     : null,
                    "Social Engineering (Phishing)": level.name === "premium"
                        ? <CustomCheck/>
                        : null,
                    // "Manual Assessments": level.name === "premium"
                    //     ? <CustomCheck/>
                    //     : null,
                    "Advanced Analytics": level.name === "premium"
                        ? <CustomCheck/>
                        : null,
                    "Highest Rigor": level.name === "premium"
                        ? <CustomCheck/>
                        : null,
                    "API Integration": level.name === "premium"
                        ? <Tooltip title={"Coming Soon"}><span><BBIconConstructionCone style={{fontSize: "1.25em"}} className={"mb-0 pb-0"}/></span></Tooltip>
                        : null,
                    "BreachRisk™ Internal Testing": (level.name === "free" || level.name === "lite")
                        ? null
                        : level.name === "pro" || level.name === "premium"
                            ? <code className={"bg-yellow p-1"} style={{fontSize: ".75em"}}>Add On Available</code>
                            : null,
                    "priceId": level.price_id && priceId
                        ? priceId
                        : null,
            }} else if(selectSubTypeToView === 1){
                return{
                    subscribed: level.subscribed,
                    id: level.id,
                    "Name": <h3>{level.name.toUpperCase()}</h3>,
                    // "Description": <em>{level.description}</em>,
                    "Price": level.monthly_price && level.name !== "free"
                        ? <p>${level.monthly_price}/month</p>
                        : level.name === "free"
                            ? <p>--</p>
                            : <p><Tooltip title={"Pricing for portfolios accounts are currently determined on an as needed basis. Please contact BreachBits for more information."}>
                            <span>
                                <BBIconQuestionSpeechBubbleRequest/>
                            </span>
                        </Tooltip>
                        </p>,
                    "Portfolio Size": level.name === "starter"
                        ? 3
                        : level.name === "pro"
                            ? 10
                            : level.name === "premium"
                                ? 25
                                : null,

                }
            }
        })

    // console.log("ManageSubscriptionsPage here is ", "subscription", subscription, "subscriptionInfo", subscriptionInfo, "subLevelsArray", subLevelsArray, "subscriptionInforArray", subscriptionInfoArray);

    return(
        <div className="animated fadeIn animation-duration-7 m-1 p-1">

            {/*<Row>*/}
            {/*    <Col className={"text-center"}>*/}
            {/*        <h1> Manage Subscription </h1>*/}
            {/*    </Col>*/}
            {/*</Row>*/}

            <Row>

                <Col lg={6}>
                    <div className={"mx-0 px-0 "}>
                        <div style={{backgroundImage: `url(${PageTitleGraphic})`,  width: "600px", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>

                    </div>
                </Col>

            </Row>
            <hr/>

            <Row>
                <Col>
                    <Widget>
                        <div className={"mb-3 pb-3 mx-4 px-4"}>

                            <Row className={"mb-0 pb-0"}>
                                <Col className={"mb-0 pb-0 "}>
                                    <em>
                                        <h4 className={"mb-0 pb-0 float-right"}>
                                            <Badge color={`${selectSubTypeToView === 2 ? "primary" : "lighter-gray"}`} style={{color: `${selectSubTypeToView === 2 ? "white" : "gray"}`, textDecoration: `${selectSubTypeToView === 2 ? "underline" : "none"}`}}
                                                  id={`viewBusinessButton`} onClick={()=>setSelectSubTypeToView(2)}><small> BreachRisk&trade; for Business</small></Badge>
                                            <Badge color={`${selectSubTypeToView === 1 ? "primary" : "lighter-gray"}`} style={{color: `${selectSubTypeToView === 1 ? "white" : "gray"}`, textDecoration: `${selectSubTypeToView === 1 ? "underline" : "none"}`}}
                                                   id={`viewPortfolioButton`} onClick={()=>setSelectSubTypeToView(1)}><small>BreachRisk&trade; Portfolio</small></Badge>
                                        </h4>
                                    </em>
                                </Col>
                            </Row>

                            <Row className={""}>
                                <Col>
                                    <h2 id={"manageSubscription"}>
                                        {subscriptionName}
                                    </h2>
                                </Col>
                            </Row>

                            <Row className={"mb-1 pb-1"}>
                                <Col className={'float-left'}>
                                    <h4>
                                        {subscriptionDescription}
                                    </h4>
                                </Col>
                            </Row>


                            {subscriptionInfoArray && subscriptionInfoArray[0]
                                ? Object.keys(subscriptionInfoArray[0])
                                    .filter((key)=> key !== "id" && key !== "subscribed")
                                    .map((key, index)=>
                                        <Row key={`${key}`} className={"text-center"} id={`manage_sub_table_row_${key}`}>
                                            <Col className={`${key !== "priceId" ? "border-bottom border-right border-dark" : ""}`}>
                                               <p className={`mt-1 pt-1`}><small> {(key !== "Name" && key !== "priceId" )? key.toUpperCase() : " "}</small></p>
                                            </Col>
                                            {subscriptionInfoArray.map((level)=>
                                                    <Col className={`${key !== "priceId" ? "border-bottom border-right border-dark" : ""} ${ level.subscribed && key !== "priceId" ? "bg-lighter-gray": ""}`}
                                                         key={`${key}-${level.id}`}>
                                                        {level.subscribed && key === "Name"
                                                        && <Row>
                                                            <Col>
                                                                <p  style={{marginTop: "-10%", marginBottom: '0', marginRight: "0", marginLeft: "0",}}>
                                                                    <Tooltip title={`You're subscribed to this level`}><span>
                                                                    <small>CURRENT LEVEL</small>
                                                                </span></Tooltip>
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                        }
                                                        {key !== "priceId" &&
                                                        <div className={`mt-1 pt-1 align-self-center`} style={{backgroundColor: ``}}>{level[key]}</div>}
                                                        {/*//TODO: How to make it dispolay "upgrade" only for subscriptions higher than curretn*/}
                                                        {key === "priceId" && !level.subscribed
                                                            && <div className={`mt-1 pt-1 align-self-center ${!selfManagedEligible ? "d-none" : null}`}>
                                                            <Button onClick={(event)=>handleClickSubType(level.priceId)}
                                                                    variant={"contained"}
                                                                    disabled={level.subscribed}
                                                                    id={`${level.name}_sub_select_button`}
                                                                    color={"primary"}>
                                                                SELECT
                                                            </Button>
                                                        </div>}
                                                        {key === "priceId" && level.subscribed
                                                        && <div className={`mt-1 pt-1 align-self-center ${!selfManagedEligible ? "d-none" : null}`}>
                                                            <Button variant={"contained"}
                                                                    id={"current_sub_level"}
                                                                    disabled={true}
                                                                    color={"primary"}>
                                                                Current
                                                            </Button>
                                                        </div>}

                                                    </Col>
                                            )}
                                        </Row>)
                                :   <SkeletonMangeSubscriptionTable/>
                            }

                            {!selfManagedEligible
                            && <Row className={"mt-2 pt-2"} id={`manage_sub_table_row_admin_managed`}>
                                <Col>
                                    <Button onClick={handleClick}
                                            color={"primary"}
                                            variant={"contained"}
                                            className={"float-right"}
                                            href={`mailto:support@breachbits.com?subject=Account and Subscription Management Request from ${customer && customer.CustomerName}`}>
                                        Contact BreachBits, Inc
                                         {/*<a href={`mailto:support@breachbits.com?subject=Account and Subscription Management Request from ${customer && customer.CustomerName}`}*/}
                                         {/*        style={{textDecoration: "none", color: "white"}}>*/}
                                         {/*       Contact BreachBits, Inc*/}
                                         {/*   </a>*/}
                                    </Button>
                                </Col>
                            </Row>}

                        </div>
                    </Widget>
                </Col>

            </Row>


            <hr/>
            <Row>
                <Col sm={1} lg={1}/>
                <Col>
                    <Widget styleName={`text-center`}>
                        <h2>Account History</h2>
                        <Row>
                            <Col className={"px-2"}>
                                {selfManagedEligible
                                    ? <p>Visit Stripe for payment information, billing history, or to upgrade service.</p>
                                    : <p>For payment history or to upgrade service, contact BreachBits, Inc.</p>
                                }
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Button onClick={()=>handleClick()}
                                        color={"primary"}
                                        variant={"contained"}>
                                    {selfManagedEligible
                                        ? "Find More On Stripe"
                                        : <a href={`mailto:support@breachbits.com?subject=Account History Request from ${customer && customer.CustomerName}`}
                                             style={{textDecoration: "none", color: "white"}}>
                                            Contact BreachBits, Inc
                                        </a>}
                                </Button>
                            </Col>
                        </Row>
                    </Widget>
                </Col>
                <Col sm={1} lg={1}/>
            </Row>



        </div>
    )
}

export default ManageSubscriptionPage